var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSensorData(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.818237 6.24978L8.8046 10.0442L16.792 6.24978L8.8046 2.45459L0.818237 6.24978Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5369 8.61366L8.80429 11.8118L2.07247 8.61366C1.846 8.50724 1.57461 8.60269 1.46659 8.82943C1.3591 9.05563 1.45536 9.32702 1.6821 9.43478L8.60937 12.726C8.67086 12.7551 8.73771 12.7698 8.80429 12.7698C8.87086 12.7698 8.93771 12.7551 8.99921 12.726L15.9273 9.43478C16.154 9.32729 16.25 9.05563 16.1425 8.82943C16.0353 8.60269 15.7636 8.50724 15.5369 8.61366Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5369 11.3888L8.80455 14.5869L2.07247 11.3888C1.846 11.2818 1.57461 11.3778 1.46659 11.6046C1.3591 11.8313 1.45536 12.1022 1.6821 12.2104L8.60937 15.5011C8.67086 15.5308 8.73771 15.5455 8.80429 15.5455C8.87086 15.5455 8.93771 15.5308 8.99921 15.5011L15.9273 12.2104C16.154 12.1024 16.25 11.8313 16.1425 11.6046C16.035 11.3778 15.7636 11.2818 15.5369 11.3888Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSensorData);
export default __webpack_public_path__ + "static/media/SensorData.ebb9b879.svg";
export { ForwardRef as ReactComponent };